import React from 'react';
import { Tooltip, Button } from 'antd';
import cn from 'classnames';
import DropdownButton from '../../common/DropdownButton/DropdownButton';
import { addAccountAndTenantMenu } from '../../../constants/addAccountAndTenantsMenu';
import SimpleButton from '../../common/SimpleButton/SimpleButton';
import styles from './AddAndInfoButtons.module.scss';

const AddAndInfoButtons = ({
  onMenuClick,
  onInfoBtnClick,
  className,
  isList = false,
}) => {
  return (
    <div className={cn(styles.root, className)}>
      <Tooltip
        title={isList ? 'Добавить жителя или лицевой счет' : ''}
        placement="topRight"
      >
        <DropdownButton
          trigger={['click']}
          menuItems={addAccountAndTenantMenu}
          onMenuClick={onMenuClick}
          text="Добавить"
          textColor="black"
          buttonClassName={styles.dropdownBtn}
        >
          {isList && (
            <Button
              icon="plus"
              onClick={(e) => e.stopPropagation()}
              shape="circle"
              type="primary"
            />
          )}
        </DropdownButton>
      </Tooltip>
      <Tooltip
        title={isList ? 'Детальная информация' : ''}
        placement="topRight"
      >
        {isList ? (
          <Button
            icon="menu"
            onClick={onInfoBtnClick}
            shape="circle"
            type="primary"
          />
        ) : (
          <SimpleButton
            textColor="black"
            text="Детальная информация"
            onClick={onInfoBtnClick}
          />
        )}
      </Tooltip>
    </div>
  );
};

export default AddAndInfoButtons;
